import React from 'react'
import { SWRConfig } from 'swr'

import fetcher from './helpers'

export const IMMUTABLE_SWR_CONFIG = {
  revalidateIfStale: true,
  revalidateOnFocus: false,
  revalidateOnReconnect: false
}

const ApiProvider = ({ children }) => (
  <SWRConfig value={{ fetcher }}>{children}</SWRConfig>
)

export default ApiProvider
